export const currentDeployment = "prod";
